import React, { useState, useEffect } from "react";
import usePageMode from "hooks/usePageMode";
import IdentityCheck from "./IdentityCheck";
import EntryCertificate from "./EntryCertificate";
import RegisteredExamsList from "./RegisteredExamsList";
import RegisterFormCU from "./RegisterFormCU";
import SessionExamResults from "./SessionExamResults";
import useUserAgreement from "hooks/useUserAgreement";
import UserAgreement from "views/Common/UserAgreement/UserAgreement";
import RegisterMenu from "./RegisterMenu";

function RegisterForm() {
  const { checkUserAgreementFromApi } = useUserAgreement({
    onCheckSuccess: (res) => {
      setShowUserAgreement(!res?.data);
    }
  });
  const { pageMode, changeMultiplePageMode } = usePageMode({
    identityCheck: true,
    registerForm: false,
    validEntry: false,
    registerMenu: false
  });
  const [showUserAgreement, setShowUserAgreement] = useState(true);
  const [identityNumber, setIdentityNumber] = useState("");
  const [applicationList, setApplicationList] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);

  useEffect(() => {
    if (identityNumber) {
      checkUserAgreementFromApi(identityNumber);
    }
    initGoogleTag();
  }, [identityNumber]);

  const initGoogleTag = () => {
    if (process.env.NODE_ENV === "production" && window.location.href.includes("izmir")) {
      const scriptElement = document.createElement("script");
      scriptElement.src = "https://www.googletagmanager.com/gtag/js?id=AW-1004459239";
      scriptElement.async = true;
      const headElement = document.getElementById("indexHeadId");
      headElement.appendChild(scriptElement);

      window.dataLayer = window.dataLayer || [];

      gtag("js", new Date());
      gtag("config", "AW-1004459239");
    }
  };

  function gtag() {
    window.dataLayer.push(arguments);
  }

  return (
    <>
      {pageMode.identityCheck && (
        <IdentityCheck
          setApplicationList={setApplicationList}
          setIdentityNumber={setIdentityNumber}
          changeMultiplePageMode={changeMultiplePageMode}
        />
      )}
      {pageMode.registerMenu && <RegisterMenu changeMultiplePageMode={changeMultiplePageMode} />}
      {selectedApplication && pageMode.validEntry && (
        <EntryCertificate
          entryDocument={selectedApplication}
          changeMultiplePageMode={changeMultiplePageMode}
          setApplicationList={setApplicationList}
        />
      )}
      {identityNumber && pageMode.registerForm && (
        <RegisterFormCU
          identityNumber={identityNumber}
          setSelectedApplication={setSelectedApplication}
          changeMultiplePageMode={changeMultiplePageMode}
          applicationList={applicationList}
          setApplicationList={setApplicationList}
        />
      )}
      {pageMode.applicationList && (
        <RegisteredExamsList
          applicationList={applicationList}
          setSelectedApplication={setSelectedApplication}
          changeMultiplePageMode={changeMultiplePageMode}
        />
      )}

      {pageMode.examResults && (
        <SessionExamResults
          identityNumber={identityNumber}
          changeMultiplePageMode={changeMultiplePageMode}
        />
      )}

      {showUserAgreement && identityNumber && (
        <UserAgreement
          show={showUserAgreement}
          onHide={() => setShowUserAgreement(false)}
          identityNumber={identityNumber}
        />
      )}
    </>
  );
}

export default RegisterForm;
